import AdminSchools from './AdminSchools';
export default AdminSchools;
